import type { BatteryArbitragePresentationDto } from "~/api/dto/battery-arbitrage.dto"
import type { BatteryProposalDto } from "~/api/dto/battery-proposal.dto"

import { BillProjection, billProjectionYears } from "./bill-projection"
import { FinancialSummary } from "./financial-summary"
import { Section } from "../primitives"

/**
 * The seller's money section: the projected utility bills beside the project's
 * own money, and deliberately separate from it. The projection comes from the
 * saved run and never reduces Proposal Cost, the amount financed, or any
 * contract amount, all of which come from `FinancialSummary`.
 *
 * The recipient's `PublicBatteryInvestment` renders the same `BillProjection`
 * above its own read-only ledger, so the projection cannot differ between the
 * seller page, the homeowner link and the brochure.
 */
export function BillImpact({
  proposal,
  arbitrage,
}: {
  proposal: BatteryProposalDto
  arbitrage: BatteryArbitragePresentationDto | null
}): JSX.Element | null {
  const hasStoredPricing = proposal.proposalCost != null
  if (!billProjectionYears(arbitrage) && !hasStoredPricing) {
    return null
  }

  return (
    <Section id="investment">
      <BillProjection arbitrage={arbitrage} />
      <FinancialSummary proposal={proposal} />
    </Section>
  )
}
